<script>
	import { onMount } from "svelte";
	import { isInViewport } from "../../../utils";
	export let options = [];
	export let value;
	export let onToggle = null;
	export let scrollOnMobile = false;
	export let centered = false;

	$: activeIndex = options.findIndex((o) => o.id === value);

	let container;
	let rightEnd = false;
	let leftEnd = true;

	const checkForGradient = () => {
		if (!container) return;
		const difference = container.scrollLeft + container.offsetWidth - container.scrollWidth;
		rightEnd = Math.abs(difference) < 1;
		leftEnd = container.scrollLeft < 1;
	};

	onMount(() => {
		checkForGradient();
	});

	$: options, checkForGradient();
</script>

<!-- Enable focus trapping on the buttons container -->
<div class="buttons-container" tabindex="-1">
	<!-- Add ARIA roles and labels to the buttons container -->
	<div
		class="buttons"
		class:scrollOnMobile
		class:centered
		bind:this={container}
		role="list"
		aria-label="Button options"
		on:scroll={() => {
			checkForGradient();
		}}
	>
		{#each options as o, j}
			{@const active = o.id === value}
			{@const color = o.color}
			{@const isFirst = j === 0}
			{@const isLast = j === options.length - 1}
			{@const isMiddle = !isFirst && !isLast}
			<div
				class="button"
				class:active
				role="listitem"
				bind:this={o.elem}
				on:click={(e) => {
					value = o.id;
					if (onToggle) onToggle(o);
					container.scrollTo({
						left: 0,
						behavior: "smooth",
					});
					// if (!isInViewport(o.elem))
					// 	container.scrollTo({
					// 		left: j === 0 ? 0 : o.elem.offsetLeft - 10,
					// 		behavior: "smooth",
					// 	});
				}}
			>
				<!-- Provide an accessible name using aria-label or aria-labelledby attributes -->
				<slot option={o} {active} {color} {isFirst} {isMiddle} {isLast} aria-label="Button option" />
			</div>
		{/each}
	</div>
	<div class="gradient left" class:hidden={leftEnd} role="presentation" />
	<div class="gradient right" class:hidden={rightEnd} role="presentation" />
</div>

<style lang="scss">
	.buttons-container {
		position: relative;

		&:focus {
			outline: none;
		}
	}

	.buttons {
		text-align: center;
		display: flex;
		flex-wrap: wrap;
		gap: 6px;

		&.centered {
			justify-content: center;
		}

		&.scrollOnMobile {
			@media (max-width: $breakpoint-tablet-l) {
				width: 100%;
				overflow-x: scroll;
				flex-wrap: nowrap;
				-webkit-overflow-scrolling: touch;
				scrollbar-width: none;
				-ms-overflow-style: none;
				scroll-snap-type: x mandatory;
				scroll-padding: 20px;
			}

			&::-webkit-scrollbar {
				display: none;
			}
		}
	}

	.gradient {
		position: absolute;
		top: 0;
		width: 10%;
		height: 100%;
		pointer-events: none;
		transition: opacity 0.4s ease;

		&.right {
			right: 0;
			background-image: linear-gradient(to right, rgba(255, 255, 255, 0), $main-blue);
		}

		&.left {
			left: 0;
			background-image: linear-gradient(to left, rgba(255, 255, 255, 0), $main-blue);
		}

		&.hidden {
			opacity: 0;
		}
	}

	@media (min-width: #{$breakpoint-tablet-l + 1px}) {
		.gradient {
			display: none;
		}
	}

	.button {
		position: relative;
		white-space: nowrap;
		user-select: none;
		-webkit-tap-highlight-color: transparent;
		cursor: pointer;
		transition: background-color 0.3s ease, color 0.3s ease;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.button.active {
		pointer-events: none;
	}
</style>
